import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLayout } from 'src/contexts/layout-context';
import { Client } from 'src/pages/client-management/types/client.types';
import { getUserClients } from 'src/redux/user/user.selectors';
import { setUserStateActiveClient } from 'src/redux/user/user.slice';

const ClientSeatsTab: React.FC = () => {
  const clients = useSelector(getUserClients);
  const { setSidebarCollapsed } = useLayout();
  const dispatch = useDispatch();

  useEffect(() => {
    setSidebarCollapsed(true);
  }, [setSidebarCollapsed]);

  const handleSetActiveClient = (client: Client) => {
    dispatch(setUserStateActiveClient(client));
    setSidebarCollapsed(false);
  };


  return (
    <div className="p-4">
      <h2 className="text-2xl font-normal mb-4">
        Available Seats
      </h2>
      <div
        className="
      grid
      grid-cols-1        /* mobile: 1 card wide */
      sm:grid-cols-2     /* small tablets / desktops: 2 */
      md:grid-cols-3     /* medium desktops: 3 */
      lg:grid-cols-3     /* large desktops: 4 */
      gap-4
    "
      >
        {clients?.map(client => (
          <div
            onClick={() => handleSetActiveClient(client)}
            key={client.ext_client_id}
            className="bg-white rounded-lg shadow cursor-pointer p-6 flex flex-col hover:shadow-lg transition-all duration-300"
          >
            <div className="flex-1 mb-4">
              {client?.brand ?(
                <img
                  src={client?.brand ?? ''}
                  alt={client?.title ?? 'Unknown Client'}
                  className="w-full h-48 object-contain rounded"
                />
              )
                : (
                  <div className="w-full h-40 object-contain rounded bg-gray-200">
                    <div className="flex items-center justify-center h-full">
                      <span className="text-lg font-normal">
                        {client?.title ?? 'Unknown Client'}
                      </span>
                    </div>
                  </div>
                )}
            </div>

          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientSeatsTab;